import styled from 'styled-components';
import { FontFamily, FontSize, FontWeight, ScreenWidth } from 'web-common/src/shared/styles';

export const WaitlistHeaderContainer = styled.div`
  font-size: ${FontSize.SEMI_HUGE};
  @media (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${FontSize.XXL};
  }
`;
export const WaitlistContainer = styled.div`
  text-align: center;
  max-width: 90%;
  margin: 0px auto;
  padding-top: 20px;
  font-weight: ${FontWeight.NORMAL};
  font-family: ${FontFamily.SANS};
`;
export const WaitlistSublabel = styled.p`
  font-size: ${FontSize.M};
  @media (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${FontSize.XS};
  }
`;
